import { v4 as uuidv4 } from "uuid";
import utils from "./utils";

export const getDeviceGuid = utils.memoizeLocalStorage("deviceGuid", () => uuidv4());
